import { jsPDF } from "jspdf";
import { PDFGenerator } from "./pdf-generator";

export class BasePdfGenerator {
  // @ts-expect-error It will be initialized in the child class
  protected pdf: PDFGenerator;
  // @ts-expect-error It will be initialized in the child class
  protected doc: jsPDF;

  protected readonly title = "Link Pharmacy";
  protected readonly fontSize = 8;
  // protected readonly lineHeight = 5;
  protected readonly margin = 4;
  protected readonly titleFontSize = 14;
  // protected readonly subTitleFontSize = 8;
  protected readonly fontFamily = "Helvetica";

  protected readonly pageWidth = 70;

  protected readonly TEXT_HEIGHT_MULTIPLIER = 0.5;

  protected heightUsed = 0;

  constructor() {
    // this.pdf = new PDFGenerator({ height: docHeight < 100 ? 100 : docHeight });
    // this.doc = this.pdf.getDoc();
    // this.pdf.setup();
  }

  protected setTitle() {
    this.doc.setFontSize(this.titleFontSize);

    const heightPoint = this.TEXT_HEIGHT_MULTIPLIER * 2;

    this.doc.text(
      this.title,
      this.doc.internal.pageSize.width / 2,
      this.calculateRequiredHeight(heightPoint),
      {
        align: "center",
      },
    );

    this.addHeightUsed(heightPoint);
  }

  protected addHeightUsed(height: number) {
    const requiredHeight = this.getRequiredHeight(height);
    this.heightUsed += requiredHeight;
  }

  protected getRequiredHeight(heightPoint: number, fontSize?: number) {
    const fsz = fontSize || this.fontSize;

    const multiplier = 1;

    return fsz * multiplier * heightPoint;
  }

  protected calculateRequiredHeight(height: number) {
    const requiredHeight = this.getRequiredHeight(height);

    return this.getHeightUsed() + requiredHeight;
  }

  protected getHeightUsed() {
    return this.heightUsed;
  }

  public print() {
    this.pdf.print();
  }
}
